import bold from "../default-icons/bold";
import strikethrough from "../default-icons/strikethrough";
import italic from "../default-icons/italic";
import quote from "../default-icons/quote";
import heading2 from "../default-icons/heading2";
import heading3 from "../default-icons/heading3";
import heading4 from "../default-icons/heading4";
import unorderedList from "../default-icons/unorderedList";
import orderedList from "../default-icons/orderedList";
import horizontalRule from "../default-icons/horizontalRule";
import link from "../default-icons/link";
import image from "../default-icons/image";
import video from "../default-icons/video";
import attachment from "../default-icons/attachment";
import code from "../default-icons/code";
import table from "../default-icons/table";
import copyHtml from "../default-icons/copyHtml";
import previewOff from "../default-icons/previewOff";
import preview from "../default-icons/preview";
import help from "../default-icons/help";
import upload from "../default-icons/upload";
export default { bold, strikethrough, italic, quote, heading2, heading3, heading4, unorderedList, orderedList, horizontalRule, link, image, video, attachment, code, table, copyHtml, previewOff, preview, help, upload };
